import AssetType from "../enum/AssetType";

export function preloadImage(url){

    return new Promise((resolve, reject) => {

        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}

export async function preloadVideo(url){

    const videoRequest = await fetch(url);
    const blob = await videoRequest.blob();

    new Promise((resolve, reject) => {

        const video = document.createElement("video");
        video.onloadeddata = () => resolve(true);
        video.onerror = () => resolve(false);
        video.src = URL.createObjectURL(blob);
    });
}

export async function preloadAssets(assets, progressCallback = null) {

    let promises = [];

    let progressIndex = 0;

    const updateProgress = () => {

        progressIndex++;

        if (progressCallback != null) {
            progressCallback((progressIndex / assets.length) * 100);
        }
    }

    for (const asset of assets) {

        switch (asset.type) {

            case AssetType.IMAGE:

                promises.push(preloadImage(asset.url).then(updateProgress));
                break;

            case AssetType.VIDEO:

                promises.push(preloadVideo(asset.url).then(updateProgress));
                break;
        }
    }

    return Promise.all(promises).catch(() => {});
}